import React, { useState } from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";

/* =========================================================
   MAIN LAYOUT
========================================================= */

function MainLayout() {
  const theme = useTheme();

  const isMobile = useMediaQuery(
    theme.breakpoints.down("md")
  );

  const [mobileOpen, setMobileOpen] =
    useState(false);

  /*
   * Keep this value exactly the same
   * as the Sidebar drawer width.
   */
  const drawerWidth = 260;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#F6F8F9",
        display: "flex",
        overflow: "hidden",
      }}
    >
      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <Sidebar
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      {/* =====================================================
          MAIN AREA
      ===================================================== */}

      <Box
        sx={{
          flexGrow: 1,
          width: {
            xs: "100%",
            md: `calc(100% - ${drawerWidth}px)`,
          },

          minWidth: 0,
          minHeight: "100vh",

          display: "flex",
          flexDirection: "column",

          backgroundColor: "#F6F8F9",

          overflow: "hidden",
        }}
      >
        {/* ===================================================
            HEADER
        =================================================== */}

        <Header
          onMenuClick={() =>
            setMobileOpen(true)
          }
        />

        {/* ===================================================
            PAGE CONTENT
        =================================================== */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,

            width: "100%",
            minWidth: 0,

            minHeight: 0,

            overflowY: "auto",
            overflowX: "hidden",

            backgroundColor:
              "#F6F8F9",

            /*
             * IMPORTANT:
             * Do NOT use maxWidth here.
             * Do NOT use mx: "auto".
             */
            boxSizing: "border-box",

            "&::-webkit-scrollbar": {
              width: "6px",
            },

            "&::-webkit-scrollbar-thumb": {
              backgroundColor:
                "#D0D5DD",
              borderRadius: "10px",
            },

            "&::-webkit-scrollbar-track": {
              backgroundColor:
                "transparent",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default MainLayout;